import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTableModule } from 'angular-6-datatable';

import { DatatableKeyboardModule } from '../directives/datatable-keyboard/datatable-keyboard.module';
import { LicenseSearchRoutingModule } from './public-license-search-routing.module';
import { PublicLicenseSearchComponent } from './public-license-search.component';

@NgModule({
  imports: [
    CommonModule,
    LicenseSearchRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    DataTableModule,
    DatatableKeyboardModule,
    NgbModule
  ],
  declarations: [PublicLicenseSearchComponent]
})
export class LicenseSearchModule { }
